
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/termos-e-condicoes",
      function () {
        return require("private-next-pages/termos-e-condicoes/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/termos-e-condicoes"])
      });
    }
  